import React, { Fragment } from 'react'
import Logo from '@app/components/shared/Logo'
import Friendship from '@app/components/shared/StateLabel/Friendship'
import Platform from '@app/components/Landing/Platform'
import StateLabel from '@app/components/shared/StateLabel'
import { LandingPart } from '@app/components/shared/students/LandingPart'
import classnames from 'classnames'
import SVG from 'react-inlinesvg'
import calendar from '@icons/calendar/yellow'

const ComingSoon = ({ student, global }) => {
  const date = I18n.l("date.formats.long", global.event.trial_tour_starts_at)

  const classes = classnames(
    'page', 'student-tasks-page',
    'student-tasks-page--landing'
  )

  return (
    <Fragment>
      <div className={classes}>
        <div className="student-tasks-page__inner">
          <div className="student-tasks-page__title">
            <div className="w-flex-layout__center">
              <div className="w-flex-layout w-flex-layout--columns w-flex-layout--jc-center">
                <div className="header-section__logo">
                  <SVG src={global.event.logo}/>
                </div>
                <h4 className="white f--white header-section__heading">
                  {I18n.t("landing.video_heading")}
                </h4>
                <p className="f--white mt-0 header-section__hint">
                  {I18n.t("landing.participants")}
                </p>
              </div>
            </div>
            <div className="student-tasks-page__center" />
          </div>
          <div className="student-tasks-page__content-wrapper">
            <Friendship event={global.event} />
            <div className="student-tasks-page__panel text-center">
              <SVG src={calendar} className="student-tasks-page__icon text-center" />

              <h1 className="student-tasks-page__status text-center xl my-1">
                {
                  I18n.t('before_trial_tour', {
                    scope: 'olympic_participation_decorator.timeline_readable_tour_date',
                    date: date
                  })
                }
              </h1>

              <p className="paragraph black text-center">
                { I18n.t('students.before_trial_tour.status') }
              </p>
            </div>
          </div>
          <Platform className="pt-1" theme="white" />
          <div className="student-tasks-page__state_label">
            <StateLabel event={global.event} />
          </div>
        </div>
      </div>
      <LandingPart student={student} global={global} />
    </Fragment>
  )
}

export default ComingSoon
